import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogContent } from "@mui/material";
import { InputNumerico } from "app/components/inputs/InputNumerico";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import React from "react";
import * as R from "ramda";
import { PaperArrastavel } from "../../../dialog-arrastavel/PaperArrastavel";

const estilosBotoes = require("../../../../estilos/botoes.module.scss").default;
const estilosInputs = require('../../../../estilos/inputs.module.scss').default


export type CreditoCancelamento = {
    ValorNotaCreditoSobreProdutos: number
    ValorNotaCreditoSobreFreteDespesas: number
    ValorNotaCreditoSobreProdutosAlterado: number
    ValorNotaCreditoSobreFreteDespesasAlterado: number
}

export type ModalConfirmarCreditoCancelamentoProps = {
    open: boolean;
    percentualMaximoAlteracao: number
    creditoCancelamento: Partial<CreditoCancelamento>
    onFecharModal: () => void;
    onConfirmar: (valorNotaCreditoGerar: number) => void
    onCancelar: () => void
    onErrorValidacao: (formik: FormikErrors<CreditoCancelamento>) => void
}


export const ModalConfirmarCreditoCancelamento = (props: ModalConfirmarCreditoCancelamentoProps) => {

    const formik = useFormik({
        initialValues: props.creditoCancelamento,
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
        validate: (values) => {
            const mensagemValorMenorIgualAZero = (campo) => `O campo "${campo}" não pode ser menor ou igual a zero.`;
            const mensagemValorMenorAZero = (campo) => `O campo "${campo}" não pode ser menor que zero.`;
            const mensagemValorMaximo = (campo) => `O campo "${campo}" não pode ser maior que o maxímo configurado.`;
            const mensagemValorMinimo = (campo) => `O campo "${campo}" não pode ser maior que o mínimo configurado.`;

            return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
                ValorNotaCreditoSobreProdutosAlterado: values.ValorNotaCreditoSobreProdutosAlterado <= 0 ? mensagemValorMenorIgualAZero("Valor dos Produtos") :
                    (values.ValorNotaCreditoSobreProdutosAlterado > values.ValorNotaCreditoSobreProdutos * (1 + props.percentualMaximoAlteracao / 100) ? mensagemValorMaximo("Valor dos Produtos") :
                        (values.ValorNotaCreditoSobreProdutosAlterado < values.ValorNotaCreditoSobreProdutos * (1 - props.percentualMaximoAlteracao / 100) ? mensagemValorMinimo("Valor dos Produtos") : undefined)),

                ValorNotaCreditoSobreFreteDespesasAlterado: values.ValorNotaCreditoSobreFreteDespesasAlterado < 0 ? mensagemValorMenorAZero("Valor Frete / Despesas") :
                    (values.ValorNotaCreditoSobreFreteDespesasAlterado > values.ValorNotaCreditoSobreFreteDespesas * (1 + props.percentualMaximoAlteracao / 100) ? mensagemValorMaximo("Valor dos Produtos") :
                        (values.ValorNotaCreditoSobreFreteDespesasAlterado < values.ValorNotaCreditoSobreFreteDespesas * (1 - props.percentualMaximoAlteracao / 100) ? mensagemValorMinimo("Valor dos Produtos") : undefined))
            } as FormikErrors<CreditoCancelamento>)
        }
    });

    return (
        <>
            <Dialog
                maxWidth="xl"
                open={props.open}
                onClose={props.onFecharModal}
                PaperComponent={PaperArrastavel}
            >
                <div className="_px-4 _pt-4 _pb-2 _flex _justify-between _border-b-4 _border-[#f4f4f4]" data-arrastar-dialog>
                    <h4 className="_font-bold">Cancelamento - Confirmação do Valor do Crédito</h4>
                    <div>
                        <a onClick={props.onFecharModal} className={estilosBotoes.botaoPrimario}>
                            <FontAwesomeIcon icon={faTimes} />
                        </a>
                    </div>
                </div>

                <DialogContent >
                    <div className="_flex _flex-row _gap-x-6 _p-4">
                        <div className="_w-1/2 _items-center">
                            <h2 className="_text-center _mb-4 _font-bold">Valor do crédito original</h2>
                            <div className="_flex _items-center _my-2">
                                <label className="_w-48">Valor dos Produtos</label>
                                <InputNumerico valor={formik.values.ValorNotaCreditoSobreProdutos} disabled />
                            </div>
                            <div className="_flex _items-center _my-2">
                                <label className="_w-48">Valor Frete / Despesas</label>
                                <InputNumerico valor={formik.values.ValorNotaCreditoSobreFreteDespesas} disabled />
                            </div>
                            <div className="_flex _items-center _my-2">
                                <label className="_w-48">Valor Total do Crédito</label>
                                <InputNumerico valor={formik.values.ValorNotaCreditoSobreFreteDespesas + formik.values.ValorNotaCreditoSobreProdutos} disabled />
                            </div>
                        </div>

                        <div className="_w-1/2 _items-center">
                            <h2 className="_text-center _mb-4 _font-bold">Valor do crédito a ser gerado</h2>
                            <div className="_flex _items-center _my-2">
                                <label className="_w-48">Valor dos Produtos</label>
                                <InputNumerico
                                    classesInput={formik.errors.ValorNotaCreditoSobreProdutosAlterado != undefined && estilosInputs.inputComErro}
                                    onValorModificado={(valor) => formik.setFieldValue("ValorNotaCreditoSobreProdutosAlterado", valor)}
                                    valor={formik.values.ValorNotaCreditoSobreProdutosAlterado}
                                    disabled={!props.percentualMaximoAlteracao} />
                            </div>
                            <div className="_flex _items-center _my-2">
                                <label className="_w-48">Valor Frete / Despesas</label>
                                <InputNumerico
                                    classesInput={formik.errors.ValorNotaCreditoSobreFreteDespesasAlterado != undefined && estilosInputs.inputComErro}
                                    onValorModificado={(valor) => formik.setFieldValue("ValorNotaCreditoSobreFreteDespesasAlterado", valor)}
                                    valor={formik.values.ValorNotaCreditoSobreFreteDespesasAlterado}
                                    disabled={!props.percentualMaximoAlteracao} />
                            </div>
                            <div className="_flex _items-center _my-2">
                                <label className="_w-48">Valor Total do Crédito</label>
                                <InputNumerico
                                    valor={formik.values.ValorNotaCreditoSobreFreteDespesasAlterado + formik.values.ValorNotaCreditoSobreProdutosAlterado}
                                    disabled />
                            </div>
                        </div>
                    </div>

                    <div className="_flex _justify-center _items-center _my-2">
                        <button className={`_my-2 no-global-button _mx-2 ${estilosBotoes.botaoPrimario}`}

                            onClick={async () => {
                                const erros = await formik.validateForm(formik.values)
                                if (Object.keys(erros).length == 0) {
                                    props.onConfirmar(formik.values.ValorNotaCreditoSobreFreteDespesasAlterado + formik.values.ValorNotaCreditoSobreProdutosAlterado)
                                } else {
                                    props.onErrorValidacao(erros)
                                }
                            }}>
                            Confirmar
                        </button>
                        <button className={`no-global-button ${estilosBotoes.botaoPrimario}`}
                            onClick={() => props.onCancelar()}>
                            Cancelar
                        </button>
                    </div>



                </DialogContent>

            </Dialog>
        </>
    )
}